import useAPI from '@/hooks/useAPI';
import ScheduleRepository from '@/repositories/ScheduleRepository';

export const useSchedules = () => {
  const scheduleRepository = ScheduleRepository();

  return useAPI({
    queryKey: ['getSchedules'],
    queryFn: async () => await scheduleRepository.list()
  });
};

export default useSchedules;
